import { render, staticRenderFns } from "./PassStatus.vue?vue&type=template&id=4b173281&"
import script from "./PassStatus.vue?vue&type=script&lang=js&"
export * from "./PassStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports